// import BarChartIcon from '@mui/icons-material/BarChart';
// import GroupIcon from '@mui/icons-material/Group';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import FilterDramaOutlinedIcon from '@material-ui/icons/FilterDramaOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import WatchLaterOutlinedIcon from '@material-ui/icons/WatchLaterOutlined';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import { Box, Button, Card, CardContent, Container, Grid, Typography } from '@mui/material';
const features = [
    // { icon: TrackChangesIcon, title: 'Topic Pulse', description: 'Build your own plan — pick the right test immediately after preparing the topic and get instant performance reviews.', color: '#f97316' },
    { icon: FilterDramaOutlinedIcon, title: 'Cloud-Based Accessibility', description: 'Dive into ready-made content, including question banks for engineering and medical streams, test series, and more.', color: 'linear-gradient(to bottom right, #05a7c7, #00d4ff);' },
    { icon: CheckBoxOutlinedIcon, title: 'Personalized Tests', description: 'Educators can create customized tests tailored to their goals, giving students focused practice where it matters most.', color: 'linear-gradient(to bottom right, #FEBD33, #F67934);' },
    { icon: WifiOffIcon, title: 'Seamless Offline Support', description: 'Whether online or offline, maintain consistency. Our platform provides flexibility for varied assessment environments.', color: 'linear-gradient(to bottom right, #27ACB3, #DEC746);' },
    { icon: BarChartOutlinedIcon, title: 'Actionable Insights', description: 'Leverage detailed analytics to identify learning gaps, track progress, and drive continuous improvement for both educators and students.', color: 'linear-gradient(to bottom right, #F67934, #FEBD33);' },
    { icon: WatchLaterOutlinedIcon, title: 'Exam Simulation', description: 'Bring test environments to life by offering realistic exam simulations that allow students to practice with timed sessions.', color: 'linear-gradient(to bottom right, #DEC746, #27ACB3);' },
    { icon: VerifiedUserOutlinedIcon, title: 'Support Major Exam Patterns', description: 'From JEE, CET, to NEET, our platform caters to key competitive exams, ensuring your students are exam-ready.', color: 'linear-gradient(to bottom right, #05a7c7, #00d4ff);' },
];

const Features = ({ setShowForm }) => {
    return (
        <Box
            id="services"
            sx={{
                py: 8,
                background: '#ffffff'
            }}>
            {/* '#EFF3F7' */}
            <Container maxWidth="100%" sx={{ textAlign: 'center' }}>
                <Box sx={{ textAlign: 'center', mb: 8 }}>
                    <Typography
                        sx={{
                            mb: 2,
                            fontWeight: 700,
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            color: '#0f1a24',
                            fontSize: '2.25rem',
                            lineHeight: '2.5rem'
                        }}>
                        Key services
                    </Typography>
                    <Typography variant="h6" color="text.secondary"
                        sx={{
                            maxWidth: '800px',
                            mx: 'auto',

                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            color: '#65758b',
                            fontWeight: '400',
                            fontSize: '0.98rem',
                            lineHeight: '1.625rem',
                            color: '#6c7993',
                            textTransform: 'none'
                        }}>
                        Revolutionizing education with smart solutions
                    </Typography>
                </Box>
                <Grid container spacing={4}>
                    {features.map((feature, index) => (
                        <Grid item xs={12} md={6} lg={4} key={index}>
                            <Card sx={{
                                textAlign: 'left',
                                boxShadow: 'none',
                                borderRadius: '1rem',
                                height: '100%',
                                transition: 'all 0.3s ease',
                                border: '1px solid #d1d9e0',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow: 6
                                }
                            }}>
                                <CardContent sx={{ p: 4 }}>
                                    <Box sx={{ width: 56, height: 56, borderRadius: 2, background: `linear-gradient(to bottom right,hsl(217 91% 60% / .1) , hsl(262 83% 58% / .1))`, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.1)' } }}>
                                        <feature.icon htmlColor="#3c83f6" sx={{ fontSize: 28 }} />
                                    </Box>
                                    <Typography variant="h5"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 600,
                                            fontSize: '1rem',
                                            lineHeight: '2rem',
                                            color: '#0f1a24',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                        {feature.title}
                                    </Typography>
                                    <Typography color="text.secondary"
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '0.875rem',
                                            lineHeight: '1.25rem',
                                            color: '#52667a',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                        {feature.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
                <Button
                    variant="outlined"
                    size="large"
                    // endIcon={<CheckCircleOutlinedIcon />}
                    sx={{
                        mt: 4,
                        borderRadius: 3,
                        textTransform: "none",
                        fontWeight: 600,
                        background: '#fff',
                        color: '#000',
                        fontSize: '0.875rem',
                        lineHeight: '1.25rem',

                    }}
                    onClick={setShowForm}
                >
                    ✨ Become a Part of Our Ecosystem
                </Button>
            </Container>
        </Box>
    );
};
export default Features